export default __webpack_public_path__ + "static/media/project2.1e4391cf.png";